export const reduxKey = '@@DISCORD';

//# sourceMappingURL=constants.js.map